module.exports = __webpack_public_path__ + "img/icons-1.b031bd52.png";